(function(Drupal, $, once){
    Drupal.behaviors.me1 = {
        attach() {
            $(once('me1', 'body')).first().each(function(){

                const openClass = 'ME1--open';
                const $me1 = $(".ME1");
                const $overlay = $me1.children(".ME1__modal");

                $.fn.openModal = function(){
                    this.each(function(){
                        var $component = $(this);
                        $component.addClass(openClass);
                        $('body').addClass('no-scroll');
                    });
                    return $(this);
                };

                $.fn.closeModal = function(){
                    this.each(function(){
                        var $component = $(this);
                        $component.removeClass(openClass);
                        $('body').removeClass('no-scroll');
                    });
                    return $(this);
                };

                $.fn.isModalOpen = function(){
                    return $(this).first().hasClass(openClass);
                };

                $(document).click(function(event) {
                    const $modal = $(event.target);
                    if ($modal.hasClass('ME1__modal')) {
                        $modal.parent().closeModal();
                    }
                });
            });
        }
    };
})(Drupal, jQuery, once);
